var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"filter__search"},[_c('form-text',{class:['form__text--search'],attrs:{"label":'',"name":'',"value":_vm.value,"icon":true,"icon-name":'search',"placeholder":_vm.searchPlaceholder},on:{"input":_vm.emitInput}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }